import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';


export default function SelectUniversityMenu({universities}) {
    const [activeUniversity, setActiveUniversity] = useState(universities[0].slug)

    const selectUniversity = (slug) => {
        setActiveUniversity(slug)

        const event = new CustomEvent('select_university_select', { detail: slug })
        document.dispatchEvent(event)
    }
    return (
        <Container>
            {universities.map(university => {
                return (<UniversityContainer
                    active={activeUniversity === university.slug}
                    onClick={() => selectUniversity(university.slug)} key={`university_container_${university.slug}`}>{university.name}</UniversityContainer>)
            })}
        </Container>
    )

}

const UniversityContainer = styled.div`
   border: 1px solid ${props => props.active ? '#FA9F63': '#1A2024'};
    padding: 8px;
    border-radius: 4px;
    background-color: #1A2024;
    margin-top: 12px;
    &: hover {
        border: 1px solid #FA9F63;
        color: #FA9F63;
    }
    cursor: pointer;
    text-align: center;
    color: ${props => props.active ? '#FA9F63': 'white'};
`

const Container = styled.div`
    padding: 8px;
`


if (document.getElementsByTagName('select-university-menu')) {
    const elms = document.getElementsByTagName('select-university-menu')

    for(let elm of elms) {
        const universities = JSON.parse(elm.attributes['universities'].value)
        ReactDOM.render(<SelectUniversityMenu
            universities={universities}
        />, elm);
    }
}
